import { Row } from "antd";
import React from "react";
import styled from "styled-components";

import FilterBoxCard from "../../common/Card/FilterBoxCard";
import CustomerSearchInput from "@/lib/customerSearch/CustomerSearchInput";
import UserInfo from "../../common/UserInfo";
import { UserInfoDrawerSources } from "../../common/UserInfoExcerpt/UserInfoDrawer";

const HeaderWrapper = styled.div`
  margin-bottom: 35px;
`;

const Header = ({ setEmail, email }: { setEmail: Function; email: string }) => {
  return (
    <Row>
      <HeaderWrapper>
        <FilterBoxCard title="Email">
          {/* No `type="email"`: the browser would reject a Public ID
              before it is resolved. An empty box still hands over "",
              which Belege reads as "show random receipts" (SMT-1396). */}
          <CustomerSearchInput
            id="email"
            style={{ width: "280px" }}
            value={email}
            onSelect={(selected) => {
              setEmail(selected || "");
            }}
          />
        </FilterBoxCard>
      </HeaderWrapper>
      <UserInfo source={UserInfoDrawerSources.ACCOUNTING} />
    </Row>
  );
};

export default Header;
